<template>
    <div class="LoginStyle">
        <!-- <Header /> -->
        <!-- <div class="topHeader container">
            <img src="../../assets/images/Logo.png" />
        </div> -->
        <el-form
            :model="ruleForm"
            status-icon
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
        >
            <!-- <el-form-item label="机构" prop="orgGid">
                <el-select clearable filterable :filter-method="filterMethod" v-model="ruleForm.orgGid" placeholder="请选择图书馆">
                <el-option v-for="item in options" :key="item.gid" :label="item.orgName" :value="item.gid"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="用户名" prop="UserName">
                <el-input
                    v-model="ruleForm.UserName"
                    clearable
                    @keyup.native.enter="submitForm(ruleForm)"
                    placeholder="请输入用户名"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="PassWord">
                <el-input
                    type="PassWord"
                    clearable
                    @keyup.native.enter="submitForm(ruleForm)"
                    v-model="ruleForm.PassWord"
                    autocomplete="off"
                    placeholder="请输入密码"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    type="primary"
                    @click="submitForm(ruleForm)"
                    :loading="loading"
                    >{{ loading ? "登录中..." : "登录" }}</el-button
                >
            </el-form-item>
        </el-form>
        <Footer class="BootmStyle"></Footer>
    </div>
</template>

<script>

import { encrypt } from "@/common/utils/filter";
import { setItem } from "@/common/utils/localStorage.js";
import Axios from "@/api/diyaxios";
import Footer from "../../components/Footer.vue";
export default {
    name: "Login",
    data() {
        return {
            islogo: false,
            loading: false,
            ruleForm: {
                UserName: "", //'test', sxwhcmgly
                PassWord: "", //'123456', 123456
                orgGid: "",
                devType: "WEB",
                //   input: '',
                //   Selectvalue: ''
            },
            // options: [],
            // optionsSelect: [],
            // value: '请选择图书馆'
        };
    },
    mounted() {
        // 获取图书馆的数据
        // this.filterMethod('');
    },
    components: {
        //   Header,
        Footer,
    },
    methods: {
        // 登录
        submitForm() {
            let vm = this;
            this.$router.push({
                name: "newBookEntry",
            }); 
        },
    },
};
</script>

<style scoped lang="scss">
.LoginStyle {
    width: 100%;
}

.demo-ruleForm {
    width: 500px;
    margin-left: calc(50% - 300px);
    margin-top: 150px;
}

.BootmStyle {
    position: fixed;
    bottom: 0px;
}

.el-select {
    width: 400px;
}

.SearchInput {
    display: inline-block;
    width: 400px;
}

.SearchSelect {
    display: inline-block;
    width: 215px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login/Login.vue